export default "__VITE_ASSET__qDTNedFG__"